import { useState } from 'react'
import { UserMyReferralsCSS } from './UserMyReferralsCSS.styled'
import { CopyIcon } from './UserMyReferralsCSS.styled'

import { useEffect } from 'react'
import { currencyFormatter, doCopy } from 'utils'
import { config } from 'config/index'
import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { useReferralData } from 'hooks/useReferralData'

export const UserMyReferrals = () => {
  const {
    referralData: { feesEarned, usersReferred, referralCode },
    isReferralDataLoading,
  } = useReferralData()

  // start copy to clipboard logic
  const [hasCopied, setHasCopied] = useState(false)
  const makeLink = (code) => `${config.YOLO_BASE_URL}/game?referralcode=${code}`
  useEffect(() => {
    if (hasCopied) {
      const timer = setTimeout(() => {
        setHasCopied(false)
        // inputRef.current.blur()
      }, 2000)
      return () => clearTimeout(timer)
    }
  }, [hasCopied])
  const onCopy = async (event) => {
    event.preventDefault()
    event.stopPropagation()
    const copied = await doCopy(makeLink(referralCode))

    if (copied) setHasCopied(true)
  }
  // end copy to clipboard logic

  return (
    <UserMyReferralsCSS>
      <div class='user_tabs_panel' id='user-api_panel'>
        <div class='content column'>
          <div class='myreferrals_wrapper'>
            <div class='your_referral_link'>
              <div class='title'>Your referral link:</div>
              <div className='link' onClick={onCopy}>
                <SingleDataLoader
                  loading={isReferralDataLoading}
                  data={
                    <>
                      <span>{makeLink(referralCode)}</span>
                      <CopyIcon collection='general' name={hasCopied ? 'tick' : 'copy'} masking />
                    </>
                  }
                />
              </div>
            </div>
            <div class='your_data'>
              <div class='rewards_earned'>
                <div class='title'>Rewards earned:</div>
                <div class='box'>
                  <SingleDataLoader loading={isReferralDataLoading} data={currencyFormatter(feesEarned)} />
                </div>
              </div>
              <div class='total_referees'>
                <div class='title'>Total referees:</div>
                <div class='box'>
                  <SingleDataLoader loading={isReferralDataLoading} data={usersReferred} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserMyReferralsCSS>
  )
}
